var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 13.333C2.22868 13.333 1.33325 12.4376 1.33325 11.333L1.33325 4.66634C1.33325 3.56177 2.22868 2.66634 3.33325 2.66634L12.6666 2.66634C13.7712 2.66634 14.6666 3.56177 14.6666 4.66634L14.6666 11.333C14.6666 12.4376 13.7712 13.333 12.6666 13.333L3.33325 13.333Z",
    stroke: "var(--color-pi-navy-blue)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6C6.55228 6 7 6.44772 7 7C7 7.55228 6.55228 8 6 8C5.44772 8 5 7.55228 5 7C5 6.44772 5.44772 6 6 6Z",
    fill: "var(--color-pi-navy-blue)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 9.44772 4.44772 9 5 9H7C7.55228 9 8 9.44772 8 10V11H4V10Z",
    fill: "var(--color-pi-navy-blue)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdNo);
export default __webpack_public_path__ + "static/media/idNo.efc112808ebe80101215dcbf9720be3f.svg";
export { ForwardRef as ReactComponent };